
import { defineComponent, reactive, inject, ref, PropType } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";
import EventService from '@/core/services/EventService';
import { errManager, cBoolean, showNotification } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
import moment from 'moment';
import GlobalService from '@/core/services/GlobalService';

export default defineComponent({
    props:{
        setting: {
            type: Object,
            required: true,
            default: {}
        },
        itemEvent: {
            type: Object,
            required: false,
            default: {}
        },
        listSeats: {
            type: Array as PropType<any[]>,
            required: false,
            default: () => []
        }
    },
    setup(props, {emit}) {
        const { t } = useI18n();
        const store = useStore();
        const loading = ref(false);
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const altura = screen.height - 290;

        const gblAction = inject<any>('gblAction')
        const gblPeriodo = inject < any > ('gblPeriodo')

        const loader = ref(false)
        const listTypes = ref<any>([])
        const listCategorie = ref<any>([])
        const listModality = ref<any>([])
        const listStatus = ref<any>([])

        const ruleFormRef = ref < FormInstance > ()
        const form = reactive <any>({
            periodo: null,
        })
        const rules = reactive < FormRules > ({
            name: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            tipo: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            level: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            modality: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            startdate:[{
                type: 'date',
                required: true,
                message: 'Seleccione una fecha',
                trigger: ["blur","change"]
            }],
            enddate:[{
                type: 'date',
                required: true,
                message: 'Seleccione una fecha',
                trigger: ["blur","change"]
            }],
            idseat: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            place: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            slug: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            mstatus: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
        });

        const openModal = () => {
            isModalVisible.value = true;
        };

        const onOpen = () => {
            const hasData = props.itemEvent && Object.keys(props.itemEvent).length > 0;
            titleDialog.value = hasData ? t('edit') : t('register')
            
            listTypes.value = props.setting.types
            listCategorie.value = props.setting.categorie
            listModality.value = props.setting.modality
            listStatus.value = props.setting.status

            if (hasData) onEdit();
        }

        const onOpened = () => {
            /*
            if(gblAction.value == 'edit')
                onEdit()
            */
        }

        const onClosed = () => {
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            const valid = await formEl.validate();
            if(!valid) return;

            const hasData = props.itemEvent && Object.keys(props.itemEvent).length > 0;
            if(hasData)
                await update();
            else 
                await save();
        };

        const onRepeat = (data: any) => {
            loading.value = false;
                showNotification(data);
                if(data.status == 'success') {
                    isModalVisible.value = false;
                    emit("onResponse", data);
                }
        }

        const save = async() => {
            loader.value = true;
            form.periodo = gblPeriodo;
            await GlobalService.post('events/save', form)
            .then( (res) => {
                onRepeat(res.data)
            }).catch( ({response}) => {
                loader.value = false;
                errManager(response)
            })
        }

        const onEdit = async () => {
            loader.value = true
            await EventService.edit(props.itemEvent.idevent)
            .then((res) => {
                loader.value = false
                Object.assign(form, res.data)
                if(res.data){
                    form.register = cBoolean(form.register)
                    form.search_dni = cBoolean(form.search_dni)
                    form.allowed_max  = parseInt(form.allowed_max)
                }
            }).catch(({response})=>{
                loader.value = false
                errManager(response)
            })
        }

        const update = () => {
            loader.value = true
            EventService.update(form.idevent, form)
            .then( (res) => {
                loader.value = false
                emit("onResponse", res.data)
            }).catch( ({response}) => {
                loader.value = false
                errManager(response)
            })
        }

        const getUrl = () => {
            form.slug = form.name.toLowerCase().replace(/\s+/g, '-')
        }


        return {
            t,
            loading,
            isModalVisible,
            altura,
            gblAction,
            titleDialog,
            ruleFormRef,
            loader,
            form,
            rules,
            listTypes,
            listCategorie,
            listModality,
            listStatus,
            //event
            openModal,
            onOpen,
            onOpened,
            onClosed,
            onEdit,
            resetForm,
            submitForm,
            cBoolean,
            getUrl
        }
        
    },
})
